"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_components_1 = require("@zapier/common-components");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const CustomMapperStyles_1 = __importDefault(require("./CustomMapperStyles"));
const ChoiceItemContainer = ({ item, onSelect }) => {
    const onKeyDown = (e) => {
        if (e.keyCode === common_utils_1.keyCodes.Enter || e.keyCode === common_utils_1.keyCodes.Space) {
            onSelect(item.value, item);
        }
    };
    return (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceItemContainer },
        common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceItem, onClick: () => onSelect(item.value, item), onKeyDown: onKeyDown, role: "button", tabIndex: 0 },
            common_utils_1.isolateComponent(common_components_1.LogoImage, { app: item.selectedApi, borderPadding: 0, size: 18 }),
            common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceItemLabel },
                item.stepNumber,
                ". ",
                item.label),
            "\u00A0",
            common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceItemSample },
                common_utils_1.isolateComponent(design_system_1.Text, { color: "grey700", type: "altText800" }, item.sample)))));
};
exports.default = ChoiceItemContainer;
